import { render, staticRenderFns } from "./WillOtherPropertiesOccupiedFriendsYN.vue?vue&type=template&id=2564a9ae"
import script from "./WillOtherPropertiesOccupiedFriendsYN.vue?vue&type=script&lang=js"
export * from "./WillOtherPropertiesOccupiedFriendsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports